// Mock data for Trayaksh Technology Company Profile

export const companyInfo = {
  name: "Trayaksh Technology",
  tagline: "Empowering Businesses with Innovative IT Solutions",
  phone: "+91-9167232388",
  email: "info@trayakshtech.com",
  website: "www.trayakshtech.com",
  logo: "https://customer-assets.emergentagent.com/job_3df1fb57-28e7-45ff-90a0-e151608ff6ee/artifacts/ll3ap9l5_1606278341186_tt%20logo.jpg"
};

export const heroData = {
  title: "Leading IT System Integration & Professional Services",
  subtitle: "Your Reliable Partner for Enterprise IT Solutions",
  description: "Trayaksh Technology provides comprehensive IT consultancy, embedded PC solutions, software development, and professional services to enterprises across diverse verticals.",
  backgroundImage: "https://images.pexels.com/photos/4508751/pexels-photo-4508751.jpeg"
};

export const aboutData = {
  title: "About Trayaksh Technology",
  description: "One of the few IT system integration, professional service and software development companies that works with Enterprise systems. As a privately-owned company, Trayaksh Technology provides IT Consultancy, Embedded PC Solutions, software design and development as well as professional services and hardware deployment and maintenance.",
  extendedDescription: "We are a company which intends to be in front of the client's needs, deeply understanding clients' business and delivering and optimizing IT solutions from the initial phase of scoping the requirements, up to the final delivery, maintenance and continuous upgrade.",
  image: "https://images.unsplash.com/photo-1522071820081-009f0129c71c",
  values: [
    {
      title: "Desire for Excellence",
      description: "Committed to delivering premium quality in every project"
    },
    {
      title: "Trust & Confidence",
      description: "Building long-term partnerships based on reliability"
    },
    {
      title: "Innovation",
      description: "Embracing cutting-edge technologies and solutions"
    },
    {
      title: "Transparency",
      description: "Open communication and honest business practices"
    },
    {
      title: "Teamwork",
      description: "Collaborative approach to solve complex challenges"
    }
  ]
};

export const missionVision = {
  mission: {
    title: "Our Mission",
    description: "To enhance the business operation of our clients by developing and implementing premium IT products and services. We provide high quality software development, professional consulting and development outsourcing that improve our customers' operations.",
    points: [
      "Making access to information easier and securer",
      "Improving communication and data exchange",
      "Providing customers with Value for Money",
      "Providing employees with meaningful work and advancement opportunities"
    ]
  },
  vision: {
    title: "Our Vision",
    description: "To be a leading IT company for Consulting Services and Deployment of best-of-breed Business Solutions. We strive to achieve 100% customer satisfaction by delivering quality products and services at an affordable cost.",
    points: [
      "Become a leading IT solutions provider",
      "Achieve 100% customer satisfaction",
      "Continuous innovation and improvement",
      "Expand expertise in emerging technologies"
    ]
  }
};

export const servicesData = {
  title: "Our Solutions & Services",
  subtitle: "Comprehensive IT Solutions for Modern Enterprises",
  image: "https://images.unsplash.com/photo-1683322499436-f4383dd59f5a",
  categories: [
    {
      id: 1,
      category: "Hardware Solutions",
      items: [
        {
          name: "Thin Client & Mini PC",
          title: "Compact Computing Power",
          description: "Space-efficient Mini PCs perfect for digital signage, edge computing, retail automation, and space-constrained office deployments.",
          specs: [
            "Intel Core i3–i9 / AMD Ryzen 3–9",
            "Up to 64 GB DDR5 RAM",
            "NVMe PCIe SSD",
            "Fanless & Low-Power Options"
          ]
        },
        {
          name: "Workstation",
          title: "Professional-Grade Performance",
          description: "High-end workstations engineered for CAD/CAM, 3D rendering, AI/ML, video editing, and scientific simulations.",
          specs: [
            "Intel Xeon W / AMD Threadripper",
            "ECC RAM up to 512 GB",
            "NVIDIA RTX / Quadro GPU",
            "RAID / NVMe Arrays"
          ]
        },
        {
          name: "POS System",
          title: "Seamless Point of Sale",
          description: "All-in-one POS terminals for retail, restaurants, hospitality, and F&B — built for reliability in 24/7 transaction-heavy environments.",
          specs: [
            "Touch AIO POS Terminals",
            "Barcode & Receipt Printers",
            "Cash Drawer Integration",
            "POS Software Ready"
          ]
        },
        {
          name: "Industrial PC & Panel PC",
          title: "Built Tough for Industry",
          description: "Ruggedized IPC and Panel PCs for factory automation, SCADA, outdoor kiosks, and any harsh industrial deployment.",
          specs: [
            "IP65 / IP67 Rated",
            "Wide Temp: -20°C to +70°C",
            "Capacitive Touch Panel PCs",
            "DIN Rail / Panel Mount"
          ]
        },
        {
          name: "Rack & Tower Server",
          title: "Enterprise Server Infrastructure",
          description: "Enterprise-class rack-mount and tower servers from top OEMs, precisely configured for your compute, virtualization, or database workloads.",
          specs: [
            "1U / 2U / 4U / Blade Servers",
            "Tower Servers (Entry–Enterprise)",
            "Hot-Swap Drive Bays & Redundant PSU",
            "GPU Compute Servers"
          ]
        },
        {
          name: "Enterprise Storage",
          title: "Scalable Data Infrastructure",
          description: "High-performance and highly available storage solutions spanning All-Flash SAN, hybrid NAS, and unified arrays for data-intensive workloads.",
          specs: [
            "All-Flash & Hybrid SAN Arrays",
            "Scale-Out NAS",
            "Fibre Channel / iSCSI / NFS",
            "Petabyte-Scale Capacity"
          ]
        },
        {
          name: "Digital Signage",
          title: "Digital Signage Solutions",
          description: "End-to-end digital signage ecosystem — media players, commercial-grade displays, video walls, CMS software, and installation. Ideal for retail, hospitality, airports, and corporate lobbies.",
          specs: [
            "Media Players & Display Hardware",
            "Video Wall Systems",
            "Content Management Software (CMS)",
            "Remote Monitoring & Management"
          ]
        },
        {
          name: "Kiosk & Interactive Kiosk",
          title: "Kiosk & Interactive Kiosk",
          description: "Bespoke self-service kiosk solutions for ticketing, bill payments, visitor management, wayfinding, and product catalogs. Ruggedized enclosures with multi-touch displays and integrated peripherals.",
          specs: [
            "Bill Payment & Ticketing Kiosks",
            "Visitor Management Kiosks",
            "Outdoor Weatherproof Enclosures",
            "Integrated Printers, Scanners & Card Readers"
          ]
        }
      ]
    },
    {
      id: 2,
      category: "Security & Infrastructure",
      items: [
        {
          name: "Firewall & DLP Solutions",
          title: "Next-Gen Network Security",
          subtitle: "Firewall & DLP Solutions",
          description: "Protect your network perimeter and sensitive corporate data with next-generation firewalls and comprehensive Data Loss Prevention platforms.",
          specs: [
            "NGFW / UTM Appliances",
            "DLP — Network & Endpoint",
            "Web Content & Email Filtering",
            "Zero Trust / SD-WAN Ready"
          ]
        },
        {
          name: "Antivirus & Endpoint Solutions",
          title: "Complete Endpoint Protection",
          subtitle: "Antivirus & Endpoint Security",
          description: "Comprehensive endpoint protection against ransomware, malware, APT, and zero-day attacks with centralized management and real-time intelligence.",
          specs: [
            "EDR / XDR Platforms",
            "Centralised Management Console",
            "Windows / Linux / Mac Coverage",
            "Real-Time Threat Intelligence"
          ]
        },
        {
          name: "Network Security & Threat Management Audit",
          title: "Network Security & Threat Management Audit Solutions",
          description: "Comprehensive network security and threat management audit solutions designed to identify vulnerabilities, ensure compliance, and protect IT infrastructure through advanced security assessments and proactive risk management."
        }
      ]
    },
    {
      id: 3,
      category: "Industry-Specific Solutions",
      items: [
        {
          name: "Healthcare IT Solutions",
          title: "Healthcare IT Solutions",
          description: "Specialized technology for hospitals, clinics, and diagnostic centers — from medical-grade workstations and PACS systems to patient bedside terminals, nurse call integration, and compliant data storage.",
          specs: [
            "Medical-Grade Workstations & Displays",
            "PACS / RIS / HIS Systems",
            "Patient Bedside Terminals",
            "NABH-Compliant Data Storage"
          ]
        },
        {
          name: "Banking & NBFC Solutions",
          title: "Banking and NBFC Solutions",
          description: "End-to-end technology solutions for Banking & NBFCs covering Digital Signage Systems, Self-Service Kiosks, Core Banking Infrastructure, Enterprise Hardware, and Cybersecurity Solutions for enhanced customer engagement and operational excellence."
        },
        {
          name: "Education Solutions",
          title: "Education Solutions",
          description: "End-to-end educational IT solutions including smart classrooms, digital boards, e-learning systems, and IT infrastructure to create interactive, efficient, and future-ready learning environments. RFID Solutions."
        },
        {
          name: "Retail Solutions",
          title: "Retail Solutions",
          description: "Integrated retail IT solutions including POS systems, inventory management, and customer engagement platforms to streamline operations, improve efficiency, and enhance the overall shopping experience."
        },
        {
          name: "Industrial Solutions",
          title: "Industrial Solutions",
          description: "Advanced industrial automation and control system solutions designed to optimize manufacturing processes, improve operational efficiency, and ensure reliability through robust and scalable IT infrastructure."
        }
      ]
    },
    {
      id: 4,
      category: "Consulting & Services",
      items: [
        {
          name: "IT Infrastructure AMC",
          title: "IT Infrastructure AMC",
          description: "Comprehensive Annual Maintenance Contracts covering your entire IT estate — servers, storage, network switches, desktops, and peripherals — with guaranteed SLAs, preventive visits, and priority escalation.",
          specs: [
            "Guaranteed Response & Resolution SLAs",
            "Preventive Maintenance Schedules",
            "Remote Monitoring & Alerts",
            "On-Site Engineer Visits"
          ]
        },
        {
          name: "IT Consulting Solutions",
          title: "IT Consulting Solutions",
          description: "Strategic technology advisory helping CIOs and IT heads make better decisions — from infrastructure assessment and technology roadmaps to vendor evaluation, system integration, and ongoing managed services.",
          specs: [
            "Infrastructure Audit & Assessment",
            "Technology Roadmap Planning",
            "Vendor Selection & Procurement",
            "System Integration & Project Management"
          ]
        },
        {
          name: "Chatbot Solutions",
          title: "Chatbot Solutions",
          description: "AI-powered chatbot solutions for WhatsApp, Facebook, and web platforms, enabling automated customer interactions, instant support, and enhanced user engagement with intelligent and scalable technology."
        },
        {
          name: "Website & App Development",
          title: "Website & App Development",
          description: "Custom website and mobile application development solutions designed to deliver scalable, secure, and high-performance digital platforms tailored to business needs and user experience."
        },
        {
          name: "Cloud Platform Solutions",
          title: "Cloud Platform Solutions",
          description: "Cloud platform solutions offering scalable architecture, secure infrastructure, and seamless migration services to enable agility, optimize performance, and support business growth."
        },
        {
          name: "Email Solutions",
          title: "Email Solutions",
          description: "Professional email solutions powered by Microsoft 365 and Google Workspace to enable secure business communication, seamless collaboration, and enhanced productivity."
        }
      ]
    }
  ]
};

export const whyChooseUs = {
  title: "Why Choose Trayaksh Technology",
  subtitle: "Our Differentiation Principles",
  principles: [
    {
      title: "True Collaboration",
      description: "We work alongside our clients as genuine partners, not just vendors",
      icon: "Users"
    },
    {
      title: "Complete Understanding",
      description: "Deep dive into your business to deliver solutions that truly fit",
      icon: "Brain"
    },
    {
      title: "Persistence",
      description: "We stay committed until the job is done right",
      icon: "Target"
    },
    {
      title: "Customer Focus",
      description: "Your success is our success - we're dedicated to your goals",
      icon: "Heart"
    }
  ]
};

export const verticals = {
  title: "Industries We Serve",
  sectors: [
    {
      name: "Financial Services",
      description: "Banking, Insurance, and Clearing Houses",
      icon: "Building2"
    },
    {
      name: "Telecommunications",
      description: "Telco operators and service providers",
      icon: "Radio"
    },
    {
      name: "Healthcare",
      description: "Hospitals and medical facilities",
      icon: "Heart"
    },
    {
      name: "Education",
      description: "Schools, colleges, and training institutions",
      icon: "GraduationCap"
    },
    {
      name: "Government",
      description: "Public sector organizations",
      icon: "Landmark"
    },
    {
      name: "Call Centers",
      description: "Customer service operations",
      icon: "Headphones"
    },
    {
      name: "Industrial",
      description: "Manufacturing and production facilities",
      icon: "Factory"
    },
    {
      name: "Retail",
      description: "Stores and e-commerce businesses",
      icon: "ShoppingCart"
    }
  ]
};

export const contactData = {
  title: "Get In Touch",
  subtitle: "Let's discuss how we can help transform your business",
  image: "https://images.unsplash.com/photo-1600880292089-90a7e086ee0c",
  info: {
    phone: "+91-9167232388",
    email: "info@trayakshtech.com",
    website: "www.trayakshtech.com"
  }
};
